import React, { Component } from 'react';
import Button from '../common/Button';
import BusinessLandingHeader from './BusinessLandingHeader.jsx';
import BusinessLandingFooter from './BusinessLandingFooter.jsx';
import { imageBasePath, appBasePath } from '../../constants/staticData';


export default class BusinessSignUpAs extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }



  render() {
    // const active = this.props.activeLink ? 'active' : '';
    return (
      <div>
        <BusinessLandingHeader router={this.props.router} activeLink={false} metaTagKey={'signup-as'} />
        <div className="main-wrapper-business">
          <div className="authBanner">
            <div className="authCard authCard-signUp">
              <h4>Customer</h4>
              <p>Find everything you need to track your success on the road.</p>
              <Button btnCallBack={(e) => {
                e.preventDefault();
                window.location.pathname = "/sign-up";
              }} btnType="red" btnSize="lg" fontSize={14} label="Sign Up as Customer" />
              <img src={`${imageBasePath}/authCard-left.png`} />
            </div>
            <div className="authCard authCard-signUp">
              <h4>Business</h4>
              <p>Find everything you need to improve your business.</p>
              <Button btnCallBack={(e) => {
                e.preventDefault();
                this.props.router.push(`${appBasePath}/sign-up`);
              }} btnType="red" btnSize="lg" fontSize={14} label="Sign Up as Business" />
              <img src={`${imageBasePath}/authCard-right.png`} />
            </div>
          </div>


        </div>
        <BusinessLandingFooter router={this.props.router} fromSignUpAs={true} />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BusinessLanding/BusinessSignUpAs.jsx